import { useParams } from "react-router-dom";

import {
  GetRiskOverviewResponse,
  useRiskOverviewQuery,
} from "../api/PaymentResults";

import type { ObjectWithId } from "utils/ObjectWithId";

import type { RuleResult } from "../models/RiskOverview";
import type { RiskRule } from "../models/RiskRule";

const DEFAULT_VALUE = {
  blockList: { ruleResults: [] as RuleResult[], bank: undefined },
  riskScore: {
    score: 0,
    threshold: 0,
    matchedRules: [] as RiskRule[],
  },
};

export function useRiskOverviewResponse() {
  const { id } = useParams<ObjectWithId>();
  const { data } = useRiskOverviewQuery({ id });

  if (!data) {
    return DEFAULT_VALUE;
  }

  return data as GetRiskOverviewResponse;
}
